import React from 'react';
import PropTypes from 'prop-types';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import LocationIcon from '@material-ui/icons/LocationOn';
import isEmpty from 'lodash.isempty';
import {
  onErrorHandler,
  ErrorBoundaryFallbackComponent,
  withErrorBoundary
} from 'components/ErrorBoundry/ErrorBoundry';
import styled, { ThemeProvider } from 'styled-components';
import theme, { media } from '../../theme/styled-theme';

const Root = styled.div`
  position: absolute;
  background: #ffffff;
  border: 1px solid ${props => props.theme.greyLight60};
  box-shadow: 0 6px 18px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  top: 0;
  text-align: left;
  margin-top: 64px;
  z-index: 100;

  ${media.forPhoneOnly`
    overflow: scroll;
    width: 100%;
  `}
`;

const Suggestions = props => {
  const {
    onClose,
    visible,
    searchKey,
    searchKeyWordOption,
    suggestion,
    onAutocompleteItemSelect,
    noResult
  } = props;

  const handleClickAway = () => {
    onClose();
  };

  if (!visible || !searchKey) return null;

  return (
    <ThemeProvider theme={theme}>
      <Root>
        <ClickAwayListener onClickAway={handleClickAway}>
          <MenuList disableAutoFocus>
            {suggestion
              && suggestion.map((item, keyIndex) => isEmpty(item) ? null : (
                <div
                  onClick={e => onAutocompleteItemSelect(e, item)}
                  onKeyDown={e => onAutocompleteItemSelect(e, item)}
                >
                  <MenuItem
                    data-cy={`cy-suggestion-${keyIndex}`}
                    value={item.place_id}
                    leftIcon={<LocationIcon />}
                    innerDivStyle={{
                      paddingLeft: '56px'
                    }}
                  >
                    {item.description || item.name}
                  </MenuItem>
                </div>
              ))}
            {noResult}
            {searchKey ? searchKeyWordOption : null}
          </MenuList>
        </ClickAwayListener>
      </Root>
    </ThemeProvider>
  );
};

Suggestions.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  searchKeyWordOption: PropTypes.node.isRequired,
  suggestion: PropTypes.arrayOf(PropTypes.any).isRequired,
  onAutocompleteItemSelect: PropTypes.func.isRequired,

  searchKey: PropTypes.string,
  noResult: PropTypes.node
};

Suggestions.defaultProps = {
  noResult: null,
  searchKey: ''
};

export default withErrorBoundary(
  Suggestions,
  ErrorBoundaryFallbackComponent,
  onErrorHandler
);
